




























































import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import UserStore from "../stores/UserStore";
import IMessage from "../models/IMessage";
import UserService from "../services/UserService";
import * as EmailValidator from 'email-validator';
import Base64 from "base64-js";
import FileSaver from 'file-saver';

@Component
export default class MessageDetail extends Vue {

  @Prop()
  editable?: boolean;

  @Prop()
  disabled?: boolean;

  @Prop({required: true})
    // @ts-ignore
  data: IMessage;
  @Inject()
  // @ts-ignore
  private userStore: UserStore;

  @Inject()
  // @ts-ignore
  private userService: UserService;

  private recipientEmailSearchTimeout?: number;
  private recipientEmailSearchValue = '';
  private recipientEmailSearchLoading = false;

  private ccEmailSearchTimeout?: number;
  private ccEmailSearchValue = '';
  private ccEmailSearchLoading = false;

  private recipientOptions: Array<any> = [];
  private ccOptions: Array<any> = [];

  get fromUser() {
    return `${this.data.from_user.full_name} (${this.data.from_user.email})`
  }

  get toUser() {
    return this.data.to.map(u => `${u.full_name} (${u.email})`).join(', ');
  }

  get ccUser() {
    return this.data.cc.map(u => `${u.full_name} (${u.email})`).join(', ');
  }

  public removeRecipientEmailItem(e: any) {
    this.data.to.splice(this.data.to.indexOf(e), 1);
  }

  removeAttachment(attachment: any) {
    this.data.attachments.splice(this.data.attachments.indexOf(attachment), 1);
  }

  downloadAttachment(attachment: any) {
    const blob = new Blob([Base64.toByteArray(attachment.content)]);
    FileSaver.saveAs(blob, attachment.file_name);
  }

  public onChangedRecipientEmailSearchValue(value: string) {
    this.recipientEmailSearchValue = value;
    if (this.recipientEmailSearchTimeout) {
      clearTimeout(this.recipientEmailSearchTimeout);
      this.recipientEmailSearchTimeout = undefined;
    }
    this.recipientEmailSearchLoading = value.trim() !== '';
    if (this.recipientEmailSearchLoading) {
      this.recipientEmailSearchTimeout = setTimeout(this.searchRecipientEmail, 1500);
    }
  }

  public removeCcEmailItem(e: any) {
    this.data.cc.splice(this.data.cc.indexOf(e), 1);
  }

  public onChangedCcEmailSearchValue(value: string) {
    this.ccEmailSearchValue = value;
    if (this.ccEmailSearchTimeout) {
      clearTimeout(this.ccEmailSearchTimeout);
      this.ccEmailSearchTimeout = undefined;
    }
    this.ccEmailSearchLoading = value.trim() !== '';
    if (this.ccEmailSearchLoading) {
      this.ccEmailSearchTimeout = setTimeout(this.searchCcEmail, 1500);
    }
  }

  public customLabel(option: any) {
    let value = option.email;
    if (option.full_name && option.full_name.length > 0) {
      value = `${option.full_name} (${value})`
    }
    return value
  }

  private searchRecipientEmail() {
    if (this.recipientEmailSearchTimeout) {
      clearTimeout(this.recipientEmailSearchTimeout);
      this.recipientEmailSearchTimeout = undefined;
    }
    const searchValue = this.recipientEmailSearchValue.trim();
    this.userService.searchUser(searchValue).then(response => {
      this.recipientOptions = response.data;
      if (this.recipientOptions.length === 0 && EmailValidator.validate(searchValue)) {
        this.recipientOptions.push({
          email: searchValue
        });
      }
      this.recipientEmailSearchLoading = false;
    });
  }

  private searchCcEmail() {
    if (this.ccEmailSearchTimeout) {
      clearTimeout(this.ccEmailSearchTimeout);
      this.ccEmailSearchTimeout = undefined;
    }
    const searchValue = this.ccEmailSearchValue.trim();
    this.userService.searchUser(searchValue).then(response => {
      this.ccOptions = response.data;
      if (this.ccOptions.length === 0 && EmailValidator.validate(searchValue)) {
        this.ccOptions.push({
          email: searchValue
        });
      }
      this.ccEmailSearchLoading = false;
    });
  }

}
